// CareLogix™ ORACLE — Animated Opportunity Graph (Phase 33 §7)
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PALETTE, scoreColor } from "@/components/animation/MotionShared";
import { predictiveApi } from "@/api/phase33Client";

const SAMPLE = ["AAPL", "MSFT", "NVDA", "GOOGL", "AMZN", "META", "TSLA", "AMD", "NFLX", "INTC"];

export default function OpportunityGraph({ testid = "opportunity-graph" }) {
  const [cards, setCards] = useState([]);
  useEffect(() => {
    let cancelled = false;
    predictiveApi.cards(SAMPLE, "stocks").then((r) => { if (!cancelled) setCards(r.data?.cards || []); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return (
    <section style={S.shell} data-testid={testid} aria-label="Opportunity Graph">
      <header style={S.head}>
        <div style={S.eyebrow}>OPPORTUNITY GRAPH™ · LIVE</div>
        <h3 style={S.title}>Cross-asset opportunity ranking</h3>
      </header>
      <ul style={S.list}>
        {cards.map((c) => (
          <motion.li key={c.symbol} style={S.row} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} data-testid={`${testid}-row-${c.symbol}`}>
            <span style={S.sym}>{c.symbol}</span>
            <div style={S.barWrap}>
              <motion.div style={{ ...S.barFill, background: scoreColor(c.scores?.opportunity_score || 0) }} initial={{ width: 0 }} animate={{ width: `${c.scores?.opportunity_score || 0}%` }} transition={{ duration: 0.8 }} />
            </div>
            <span style={{ ...S.score, color: scoreColor(c.scores?.opportunity_score || 0) }}>{c.scores?.opportunity_score || 0}</span>
          </motion.li>
        ))}
      </ul>
    </section>
  );
}

const S = {
  shell:   { background: "linear-gradient(180deg, rgba(8,32,22,0.55), rgba(4,6,8,0.85))", border: `1px solid ${PALETTE.goldGlow}`, borderRadius: 14, padding: 12, color: PALETTE.slate3, display: "flex", flexDirection: "column", gap: 8 },
  head:    { display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 8, flexWrap: "wrap" },
  eyebrow: { color: PALETTE.gold, fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: "0.22em" },
  title:   { margin: 0, color: PALETTE.goldBright, fontSize: 13 },
  list:    { margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 5 },
  row:     { display: "grid", gridTemplateColumns: "60px 1fr 40px", alignItems: "center", gap: 8 },
  sym:     { color: PALETTE.goldBright, fontFamily: "'Space Mono', monospace", fontSize: 11, fontWeight: 800 },
  barWrap: { height: 6, background: "rgba(255,255,255,0.06)", borderRadius: 2, overflow: "hidden" },
  barFill: { height: "100%" },
  score:   { fontFamily: "'Space Mono', monospace", fontSize: 11, fontWeight: 800, textAlign: "right" },
};
